import { resolveEnvironmentBrandVariant } from "@runcheetah/shared";

export const CHEETAH_LOGO_SRC =
  resolveEnvironmentBrandVariant(import.meta.env.VITE_APP_ENV, import.meta.env.DEV) ===
  "non-production"
    ? "/logo.nonprod.jpeg"
    : "/logo.jpeg";
